// Web Vitals 监控 composable
// 采集 LCP、FID、CLS、FCP、TTFB 并上报至 GA4
import { onMounted } from 'vue'
import type { Metric } from 'web-vitals'

export function useWebVitals() {
  if (import.meta.server) return

  onMounted(() => {
    // 动态导入 web-vitals，避免影响首屏加载
    import('web-vitals').then(({ onLCP, onFID, onCLS, onFCP, onTTFB }) => {
      const report = (metric: Metric) => {
        // 上报至 GA4 自定义事件
        if (typeof window !== 'undefined' && (window as any).gtag) {
          ;(window as any).gtag('event', metric.name, {
            value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
            metric_rating: metric.rating,
            non_interaction: true,
          })
        }
      }

      onLCP(report)
      onFID(report)
      onCLS(report)
      onFCP(report)
      onTTFB(report)
    }).catch(() => {
      // web-vitals 未安装时静默忽略
    })
  })
}
